import slide1 from "../images/slide/slide_1.jpeg";
import slide2 from "../images/slide/slide_2.jpeg";
import slide3 from "../images/slide/slide_3.jpeg";
import slide4 from "../images/slide/slide_4.jpeg";
import slide5 from "../images/slide/slide_5.jpeg";
import slide6 from "../images/slide/slide_6.jpeg";

const slideList = [
  {
    src: slide1,
    title: "개발자 되고싶은 분들!?",
    sub: "프론트엔드 무료 교육과정 참여하기",
  },
  {
    src: slide2,
    title: "마케팅 주니어를 찾습니다",
    sub: "1월 17일(월) 설명회 신청하기",
  },
  {
    src: slide3,
    title: "해, 커리어 EP 02 공개",
    sub: "마지막 관문 2라운드의 승자는?",
  },
  {
    src: slide4,
    title: "성과를 내는 마케팅",
    sub: "실제 사례를 공개합니다!",
  },
  {
    src: slide5,
    title: "성장하는 개발자가 되려면?",
    sub: "OOO 검색하지 말 것!",
  },
  {
    src: slide6,
    title: "포트폴리오를 부탁해!",
    sub: "디자이너의 포폴 살펴보기",
  },
];

slideList.splice(0, 0, slideList[slideList.length - 1]);
slideList.splice(0, 0, slideList[slideList.length - 2]);
slideList.push(slideList[2]);
slideList.push(slideList[3]);

export { slideList };
